import { render, staticRenderFns } from "./mintitle.vue?vue&type=template&id=7f6a31f3&scoped=true"
import script from "./mintitle.vue?vue&type=script&lang=js"
export * from "./mintitle.vue?vue&type=script&lang=js"
import style0 from "./mintitle.vue?vue&type=style&index=0&id=7f6a31f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6a31f3",
  null
  
)

export default component.exports